import { render } from "./BetRoom.vue?vue&type=template&id=46f873d1&scoped=true"
import script from "./BetRoom.vue?vue&type=script&lang=js"
export * from "./BetRoom.vue?vue&type=script&lang=js"

import "./BetRoom.vue?vue&type=style&index=0&id=46f873d1&lang=less&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f873d1"]])

export default __exports__